import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { VirtualScroller } from "primereact/virtualscroller";
import { classNames } from "primereact/utils";

export default function ParterGroupedTable({
  groupBy = { header_name: "Name", key: "manager" },
  multiData,
  totalData,
  headers = [
    { header_name: "Name", key: "name" },
    { header_name: "Company", key: "company" },
    { header_name: "Date", key: "date" },
    { header_name: "Status", key: "status" },
    { header_name: "Verified", key: "verified" },
    { header_name: "Activity", key: "activity" },
    { header_name: "Manager", key: "manager" },
    { header_name: "Balance", key: "balance" },
  ],
  items = [
    {
      name: "James Butt",
      company: "Benton, John B Jr",
      date: "2015-09-13",
      status: "unqualified",
      verified: true,
      activity: 17,
      manager: "Ioni Bowcher",
      balance: 70663,
    },
    {
      name: "Josephine Darakjy",
      company: "Chanay, Jeffrey A Esq",
      date: "2019-02-09",
      status: "proposal",
      verified: true,
      activity: 0,
      manager: "Ioni Bowcher",
      balance: 82429,
    },
    {
      name: "Art Venere",
      company: "Chemel, James L Cpa",
      date: "2017-05-13",
      status: "qualified",
      verified: false,
      activity: 63,
      manager: "Ioni Bowcher",
      balance: 28334,
    },
    {
      name: "Lenna Paprocki",
      company: "Feltz Printing Service",
      date: "2020-09-15",
      status: "new",
      verified: false,
      activity: 37,
      manager: "Ioni Bowcher",
      balance: 88521,
    },
    {
      name: "Donette Foller",
      company: "Printing Dimensions",
      date: "2016-05-20",
      status: "proposal",
      verified: true,
      activity: 33,
      manager: "Ioni Bowcher",
      balance: 93905,
    },
  ],
}) {
  const representativeBodyTemplate = (rowData) => {
    return (
      <div className="align-items-center gap-2 even:bg-secondary-darkerGray">
        <span className="font-bold text-center">{rowData[groupBy.key]}</span>
      </div>
    );
  };
  const itemTemplate = (item, options) => {
    const className = classNames(
      "flex align-items-center p-2 even:bg-secondary-buttonGray",
      {
        "surface-hover": options.odd,
      }
    );

    return <div className={className}>{item}</div>;
  };

  const multidataBodyTemplate = (rowData, index) => {
    return (
      <div className="align-items-center gap-2 even:bg-secondary-darkerGray">
        <div className="card justify-content-center ">
          {/* <VirtualScroller
            items={rowData[multiData[index]]}
            itemSize={50}
            itemTemplate={itemTemplate}
            className="border-1 surface-border border-round"
            style={{ width: "200px", height: "200px" }}
          /> */}
          {rowData[multiData[index]] &&
            rowData[multiData[index]].map((k, i) => {
              return <div className="even:bg-gray-100 ">{k}</div>;
            })}
        </div>
      </div>
    );
  };

  // const rowClass = (data) => {
  // 	return { "bg-yellow-100": data.partnerName === "Total: " };
  // };
  return (
    <div className="card">
      <DataTable
        value={items}
        rowGroupMode="rowspan"
        groupRowsBy={groupBy.key}
        sortMode="single"
        sortField="name"
        // rowClassName={rowClass}
        sortOrder={1}
        tableStyle={{ minWidth: "50rem" }}
        showGridlines={true}
        stripedRows
        emptyMessage={" "}
      >
        <Column
          field={groupBy.key}
          header={groupBy.header_name}
          body={representativeBodyTemplate}
          style={{
            minWidth: "200px",
            border: "1px solid black",
            textAlign: "center",
          }}
          align={"center"}
          headerStyle={{ backgroundColor: "#FECD08" }}
          alignHeader={"center"}
        ></Column>
        {headers.map((field, key) => {
          if (field.key !== groupBy.key) {
            if (multiData.indexOf(field.key) !== -1) {
              return (
                <Column
                  key={field.key}
                  field={field.key}
                  body={(rowData) =>
                    multidataBodyTemplate(rowData, multiData.indexOf(field.key))
                  }
                  header={field.header_name}
                  style={{
                    minWidth: "200px",
                    border: "1px solid black",
                    textAlign: "center",
                    padding: "0",
                  }}
                  headerStyle={{ backgroundColor: "#FECD08" }}
                  alignHeader={"center"}
                ></Column>
              );
            }
            return (
              <Column
                key={field.key}
                field={field.key}
                header={field.header_name}
                style={{ minWidth: "200px" }}
                headerStyle={{ backgroundColor: "#FECD08" }}
                alignHeader={"center"}
              ></Column>
            );
          }
        })}
        {/* <Column
					header="Total"
					field={"total"}
					// body={}
					style={{
						minWidth: "200px",
						border: "1px solid black",
						textAlign: "center",
						backgroundColor: "#FEF9C3",
					}}
					headerStyle={{ backgroundColor: "#FECD08" }}
					alignHeader={"center"}
				/> */}
      </DataTable>
    </div>
  );
}
